import { createFileRoute } from '@tanstack/react-router'
import { InsuranceCompany, JobType, importRunSortingColumns } from 'types'
import z from 'zod'

import { queryImportRunList } from '@api/import-run/import-run.queries'

import ensureUserRoleOnRoute from '@/lib/ensure-user-role-on-route'
import { paginationSchema, sortingSchema } from '@/lib/table'

import ImportRunsTable from './-components/import-runs-table'

const searchSchema = z.object({
  pagination: paginationSchema,
  sorting: sortingSchema(importRunSortingColumns),
  filters: z
    .object({
      insuranceCompany: z.enum(InsuranceCompany).optional(),
      jobType: z.enum(JobType).optional(),
      success: z.boolean().optional(),
    })
    .optional(),
})

export const Route = createFileRoute('/app/settings/import-runs')({
  component: RouteComponent,
  validateSearch: searchSchema,
  beforeLoad: async ({ context }) => {
    // Route requires to be an admin
    await ensureUserRoleOnRoute(context.queryClient)
  },
  loaderDeps: ({ search }) => search,
  loader: ({
    context: { queryClient },
    deps: { pagination, sorting, filters },
  }) => {
    queryClient.prefetchQuery(
      queryImportRunList({
        ...pagination,
        pageIndex: pagination.pageIndex + 1,
        filters,
        sorting,
      }),
    )
  },
})

function RouteComponent() {
  return <ImportRunsTable />
}
